"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TopBar = exports.TOP_BAR_HEIGHT = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Layout = require("design_system/Layout");
var _TopBarLink = require("./TopBarLink");
var _TopBarMenuButton = require("./TopBarMenuButton");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/**
 * Below TOP_BAR_HEIGHT is exported to `patient_app` to dynamically adjust the top padding of
 * `<main>` when the browser is resized or reloaded.
 *
 * When modifying this, make sure to update the Tailwind top padding classes (`pt-X s768:pt-Y`) applied
 * to <main> in the base Django template (ds__base.html).
 *
 * Formula for <main> top padding:
 * - For mobile: TOP_BAR_HEIGHT (exported in NavBar.tsx) + ICONS_CONTAINER_HEIGHT
 * - For desktop: TOP_BAR_HEIGHT + NAVBAR_HEIGHT (exported in NavBar.tsx)
 *
 */
const TOP_BAR_HEIGHT = 40;
exports.TOP_BAR_HEIGHT = TOP_BAR_HEIGHT;
const THEME = {
  position: "flex flex-none items-center pointer-events-auto",
  p: "px-16 gap-x-24 s768:px-24"
};
const TopBarComponent = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  let {
    className,
    children,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_Layout.Box, _extends({
    as: "ul",
    ref: ref,
    p: THEME.p,
    className: (0, _classnames.default)(THEME.position, className),
    style: {
      backgroundColor: "#00338E",
      height: TOP_BAR_HEIGHT
    },
    role: "menubar"
  }, props), children);
});
TopBarComponent.displayName = "TopBar";
const TopBar = Object.assign(TopBarComponent, {
  Link: _TopBarLink.TopBarLink,
  MenuButton: _TopBarMenuButton.TopBarMenuButton
});
exports.TopBar = TopBar;